import { notifications } from '@mantine/notifications';
import type { OrderView } from '../../../../services/orders/orders.service';
import type { OrderlineView } from '../../../../services/orderlines/orderlines.service';
import { logToBackend } from '../../../../services/client-log/client-log.service';

type AcceptPrintParams = {
  order: OrderView;
  loadOrderlines: () => Promise<OrderlineView[]>;
  printKitchenBon: (lines: OrderlineView[]) => Promise<void> | void;
  printReceipt: () => void;
};

// Summary: Prints the accepted channel order on this device; a failed bon is loud, not silent.
export async function printAcceptedAggregatorOrder({
  order,
  loadOrderlines,
  printKitchenBon,
  printReceipt,
}: AcceptPrintParams): Promise<void> {
  try {
    const lines = await loadOrderlines();
    if (lines.length > 0) {
      await printKitchenBon(lines);
    }
  } catch (error) {
    notifications.show({
      color: 'red',
      title: 'הדפסת הבון נכשלה',
      message: `הזמנה ${order.orderCode} — יש להדפיס את הבון ידנית`,
      autoClose: 5000,
    });
    logToBackend('aggregator-accept-print', 'kitchen bon failed after channel accept', {
      orderId: order.id,
      orderCode: order.orderCode,
      message: error instanceof Error ? error.message : String(error),
    }, 'error');
  }
  if (order.status === 'closed') {
    printReceipt();
  }
}
